<template>

    <article :class="['videos', filtro, obra ? 'fade' : '']">
      <Letreiro :title="titulo" />
      <section :class="tamanho">
        <div class="trabalho" v-for="trabalho in trabalhos">
          <router-link :to="{ name: 'home', params: {path: $route.params.path , cat: $route.params.cat, obra: trabalho.id} }" @mouseenter.native="destaque('dtk-'+trabalho.type)" @mouseleave.native="destaque(titulo)">
            <img :src="require('../assets/trabalhos/' + trabalho.img)" :alt="trabalho.name" />
          </router-link>
        </div>
      </section>

      <transition name="display">
        <div class="obra" v-if="obra">
          <router-link class="fecha" :to="{ name: 'home', params: {path: $route.params.path , cat: $route.params.cat} }">&#215;</router-link>
          <img :src="require('../assets/trabalhos/' + works[obra-1].img)" :alt="works[obra-1].name" />
          <div class="descricao">
            <h3>{{works[obra-1].name}}</h3>
            <div v-html="works[obra-1].texto" class="texto"></div>
          </div>
          <aside v-if="works[obra-1].link || works[obra-1].video">
            <a v-if="works[obra-1].link" :href="works[obra-1].link" target="_blank" class="link">
              ACESSE
            </a>
            <router-link class="link" v-if="works[obra-1].video" :to="{ name: 'home', params: {path: $route.params.path , cat: $route.params.cat, obra: $route.params.obra, video: works[obra-1].video} }">
              ASSISTA
            </router-link>
          </aside>
        </div>
      </transition>

      <router-link v-show="!obra" :to="{ name: 'home', params: {path: 'Trabalhos'} }">
        <div class="scroll-left">
          <span class="arrow-left">
          <!-- css generated icon -->
          </span>
        </div>
      </router-link>
    </article>

</template>

<script>
import Letreiro from '@/components/Letreiro.vue'
import works from '@/static/projetos.js'

export default {
  name: 'Videos',
  components: {
    Letreiro
  },
  data() {
    return {
      works: works,
      titulo: this.$route.params.cat == 'cinema' ? 'Cinema' :
              this.$route.params.cat == 'midias' ? 'NovasMídias' :
              this.$route.params.cat == 'producao' ? 'ProduçãoCultural' : 'Trabalhos',
      filtro: this.$route.params.cat,
      obra: this.$route.params.obra,
    }
  },
  computed: {
      trabalhos(){
          return this.filtro ? this.works.filter(w => w.type == this.filtro) : this.works.slice(0,15);
      },
      tamanho(){
          return 'tamanho' + this.trabalhos.length;
      }
  },
  methods: {
    goTo(str) {
      let link = this.$route.params.cat == str ? { name: 'home', params: { path: 'Trabalhos'} } : { name: 'home', params: { path: 'Trabalhos', cat: str } };
      this.filtro = this.$route.params.cat == str ? undefined : this.filtro;
      this.titulo = this.$route.params.cat == str ? 'Trabalhos' : str;
      this.$router.push(link);
    },
    destaque(str){
      this.destacar = str ? str : '';
    }
  },
  watch: {
    '$route' (to, from){
      this.obra   = this.$route.params.obra;
      this.vid    = this.$route.params.video ? this.$route.params.video : '';
      this.filtro = this.$route.params.cat ? this.$route.params.cat : this.filtro;
      this.titulo = this.$route.params.cat == 'cinema' ? 'Cinema' :
                    this.$route.params.cat == 'midias' ? 'NovasMídias' :
                    this.$route.params.cat == 'producao' ? 'ProduçãoCultural' : this.titulo;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.videos {transition: all .5s ease-in-out;}
.trigger-cinema .videos ,.trigger-midias .videos ,.trigger-producao .videos {
  left: 0;
}
.videos {
  position: absolute;
  top: 200vh;
  left: 100vw;
}
.videos img {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  transition: all .5s ease-in-out;
}
.videos >>> h1 {transition: all .5 ease-in-out}

section {
  display: grid;
  padding: 20px;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  grid-gap: 3px;
  overflow: visible;
}
.trabalho {
  position: relative;
  width: 100%; height: 100%;
  background-color: #ffd300;
}


.obra {position: absolute; top: calc(5vh + 20px); right: calc(5vw + 20px); bottom: calc(5vh + 20px); left: calc(5vw + 20px); background-color: #ffd300;}
.obra img {mix-blend-mode: screen; opacity: .5;}

.descricao {position: absolute; top: 20px; right: 20px; bottom: 20px; left: 20px; display: flex; justify-content: space-around; align-items: stretch; flex-direction: column;}
.descricao h3 {margin-top: 10px;}
.descricao >>> ul {list-style: none; margin: 0; padding: 0; text-align: left; font-size: small;}

.obra aside {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 40px;
  bottom: -35px; left: 0;
  display: flex;
  justify-content: space-around;
}
.obra aside .link{
  background-color: #fff;
  border-radius: 20px;
  border: 6px solid #d55349;
  font-size: large; font-weight: 800; color: #d55349;
  display: flex; align-items: center; line-height: 0;
  padding: 0 10px;
}

.fecha {
  position: absolute;
  z-index: 99;
  width: 40px; height: 40px;
  top: -30px; right: -30px;
  background-color: #fff;
  border-radius: 50%;
  border: 6px solid #d55349;
  display: flex;
  align-items: center; justify-content: space-around;
  font-size: x-large; font-weight: 800; color: #d55349;
}

.fade >>> h1 {opacity: 0;}
/* -- SETA -- */
.scroll-left {
  position: absolute;
  display: block;
  left: 0; top: 50%;
  width: 20px;
  height: 30px;
  transform: translateY(-50%);
  padding-top: 11.5px;
}
.arrow-left {
  display: block;
  margin: 0 0 -5px -6px;
}
.arrow-left::before {
  content: '';
  display: block;
  margin: auto;
  padding: 0;
  width: 5px;
  height: 5px;
  border-top: 2px solid #d55349;
  border-right: 2px solid #d55349;
  transform: rotate(225deg);
}
.scroll-left::after {
  animation: elasticus 2s cubic-bezier(1, 0, 0, 1) reverse infinite;
  display: block;
  margin-left: 2px;
  height: 2px;
  width: 15px;
  background: #d55349;
  content: ' ';
}

/* SETA */
@keyframes elasticus {
  0% {
    transform-origin: 0% 0%;
    transform: scale(0, 1);
  }
  50% {
    transform-origin: 0% 0%;
    transform: scale(1, 1);
  }
  50.1% {
    transform-origin: 100% 0%;
    transform: scale(1, 1);
  }
  100% {
    transform-origin: 100% 0%;
    transform: scale(0, 1);
  }
}

/* -- PADROES -- */
.tamanho1, .tamanho2
{ grid-template-columns: 1fr }

.tamanho3, .tamanho4
{ grid-template-columns: repeat(2, 1fr)}

.tamanho5, .tamanho7, .tamanho9
{ grid-template-columns: repeat(3, 1fr)}

.tamanho6, .tamanho8, .tamanho15
{grid-template-columns: repeat(5, 1fr)}

.tamanho10, .tamanho11
{grid-template-columns: repeat(4, 1fr)}

.tamanho3 .trabalho,
.tamanho5 .trabalho,
.tamanho7 .trabalho,
.tamanho9 .trabalho:nth-child(2n), .tamanho9 .trabalho:nth-child(5),
.tamanho10 .trabalho,
.tamanho11 .trabalho:nth-child(3n), .tamanho11 .trabalho:nth-child(3n+2),
.tamanho12 .trabalho,
.tamanho14 .trabalho:nth-child(7n+2), .tamanho14 .trabalho:nth-child(7n+4), .tamanho14 .trabalho:nth-child(7n+5), .tamanho14 .trabalho:nth-child(7n+6),
.tamanho15 .trabalho:nth-child(2), .tamanho15 .trabalho:nth-child(4), .tamanho15 .trabalho:nth-child(5), .tamanho15 .trabalho:nth-child(8), .tamanho15 .trabalho:nth-child(9), .tamanho15 .trabalho:nth-child(11), .tamanho15 .trabalho:nth-child(13)
{ grid-area: span 2 / span 1; }

.tamanho3 .trabalho:nth-child(3),
.tamanho8 .trabalho,
.tamanho9 .trabalho:nth-child(1), .tamanho9 .trabalho:nth-child(8),
.tamanho10 .trabalho:nth-child(3n), .tamanho10 .trabalho:nth-child(10n),
.tamanho11 .trabalho:nth-child(1), .tamanho11 .trabalho:nth-child(n+9),
.tamanho12 .trabalho:nth-child(3n),
.tamanho13 .trabalho:nth-child(4n+1),
.tamanho14 .trabalho:nth-child(1), .tamanho14 .trabalho:nth-child(10),
.tamanho15 .trabalho
{ grid-area: span 1 / span 2; }

.tamanho4 .trabalho:nth-child(1), .tamanho4 .trabalho:nth-child(2)
{ grid-area: span 3 / span 1; }

.tamanho5 .trabalho:nth-child(5n+1), .tamanho5 .trabalho:nth-child(5n),
.tamanho6 .trabalho,
.tamanho8 .trabalho:nth-child(4n), .tamanho8 .trabalho:nth-child(4n+1)
{ grid-area: span 1 / span 3; }

.tamanho4 .trabalho,
.tamanho6 .trabalho:nth-child(4n+1),
.tamanho7 .trabalho:nth-child(6n+1)
{ grid-area: span 2 / span 2; }

.tamanho11 .trabalho:nth-child(10), .tamanho11 .trabalho:nth-child(11),
.tamanho13 .trabalho:nth-child(9)
{ grid-area: span 1 / span 1; }



/* --- LETREIRO --- */
  .cinema h1 >>> span, .midias h1 >>> span, .producao h1 >>> span, {
    animation: none;
  }
    /* CINEMA */
    .cinema h1 >>> span:nth-child(1) { /* C */
      	grid-column: 2;
      	grid-row: 1;
      }
    .cinema h1 >>> span:nth-child(2) { /* i */
      	grid-column: 1;
      	grid-row: 2;
      }
    .cinema h1 >>> span:nth-child(3) { /* n */
      	grid-column: 8;
      	grid-row: 4;
      }
    .cinema h1 >>> span:nth-child(4) { /* e */
      	grid-column: 8;
      	grid-row: 5;
      }
    .cinema h1 >>> span:nth-child(5) { /* m */
      	grid-column: 1;
      	grid-row: 7;
      }
    .cinema h1 >>> span:nth-child(6) { /* a */
      	grid-column: 6;
      	grid-row: 8;
      }
    /* NOVAS MIDIAS */
      .midias h1 >>> span:nth-child(1) { /* N */
      	grid-column: 3;
      	grid-row: 1;
      }
      .midias h1 >>> span:nth-child(2) { /* o */
      	grid-column: 4;
      	grid-row: 1;
      }
      .midias h1 >>> span:nth-child(3) { /* v */
      	grid-column: 7;
      	grid-row: 1;
      }
      .midias h1 >>> span:nth-child(4) { /* a */
      	grid-column: 1;
      	grid-row: 2;
      }
      .midias h1 >>> span:nth-child(5) { /* s */
      	grid-column: 1;
      	grid-row: 3;
      }
      .midias h1 >>> span:nth-child(6) { /* M */
      	grid-column: 8;
      	grid-row: 5;
      }
      .midias h1 >>> span:nth-child(7) { /* í */
      	grid-column: 8;
      	grid-row: 6;
      }
      .midias h1 >>> span:nth-child(8) { /* d */
      	grid-column: 1;
      	grid-row: 7;
      }
      .midias h1 >>> span:nth-child(9) { /* i */
      	grid-column: 3;
      	grid-row: 8;
      }
      .midias h1 >>> span:nth-child(10) { /* a */
      	grid-column: 7;
      	grid-row: 8;
      }
      .midias h1 >>> span:nth-child(11) { /* s */
      	grid-column: 8;
      	grid-row: 8;
      }
    /* PRODUÇÃO CULTURAL */
      .producao h1 >>> span:nth-child(1) { /* P */
      	grid-column: 1;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(2) { /* r */
      	grid-column: 2;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(3) { /* o */
      	grid-column: 3;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(4) { /* d */
      	grid-column: 6;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(5) { /* u */
      	grid-column: 8;
      	grid-row: 2;
      }
      .producao h1 >>> span:nth-child(6) { /* ç */
      	grid-column: 1;
      	grid-row: 3;
      }
      .producao h1 >>> span:nth-child(7) { /* ã */
      	grid-column: 1;
      	grid-row: 4;
      }
      .producao h1 >>> span:nth-child(8) { /* o */
      	grid-column: 1;
      	grid-row: 5;
      }
      .producao h1 >>> span:nth-child(9) { /* C */
      	grid-column: 8;
      	grid-row: 4;
      }
      .producao h1 >>> span:nth-child(10) { /* u */
      	grid-column: 8;
      	grid-row: 5;
      }
      .producao h1 >>> span:nth-child(11) { /* l */
      	grid-column: 8;
      	grid-row: 6;
      }
      .producao h1 >>> span:nth-child(12) { /* t */
      	grid-column: 1;
      	grid-row: 7;
      }
      .producao h1 >>> span:nth-child(13) { /* u */
      	grid-column: 2;
      	grid-row: 8;
      }
      .producao h1 >>> span:nth-child(14) { /* r */
      	grid-column: 5;
      	grid-row: 8;
      }
      .producao h1 >>> span:nth-child(15) { /* a */
      	grid-column: 6;
      	grid-row: 8;
      }
      .producao h1 >>> span:nth-child(16) { /* l */
      	grid-column: 8;
      	grid-row: 8;
      }


/* --- ADAPTIVE LAYOUT -- */

@media (orientation: portrait) {
  section{grid-template-columns: repeat(7, 1fr);}
}

@media (min-width: 768px) {
  .videos {display: none;}
}
</style>
